import {
  createSerializer,
  parseAsArrayOf,
  parseAsInteger,
  parseAsString,
  useQueryState,
} from 'nuqs'
import { TbChevronsLeft, TbChevronsRight } from 'react-icons/tb'
import Link from 'next/link'
import { Text } from 'ui-kit/typography'
import { removeEmptyQueries } from 'helpers/querystring'
import { PaginationProps, usePagination } from 'hooks/usePagination'
import clsx from 'clsx'
import classes from './IntegrationsPagination.module.scss'

export const IntegrationsPagination = ({
  totalCount,
  siblingCount = 1,
  pageSize,
  currentPage,
  className,
}: PaginationProps) => {
  const searchParams = {
    search: parseAsString,
    category: parseAsString,
    page: parseAsInteger,
    filter: parseAsArrayOf(parseAsString, ','),
  }

  const [search] = useQueryState('search', parseAsString.withDefault(''))
  const [category] = useQueryState('category', parseAsString.withDefault(''))
  const [filter] = useQueryState(
    'filter',
    parseAsArrayOf(parseAsString, ',').withDefault([]),
  )

  const serialize = createSerializer(searchParams)

  function urlQueryParams(updatedPage: number) {
    return serialize(
      removeEmptyQueries({ search, category, filter, page: updatedPage }),
    )
  }

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  })

  if (currentPage === 0 || (paginationRange && paginationRange.length < 2)) {
    return null
  }

  const lastPage =
    paginationRange && paginationRange[paginationRange.length - 1]

  return (
    <nav className={clsx(classes.list, className)}>
      <Link
        key={'arrow-left'}
        href={urlQueryParams(currentPage - 1)}
        passHref
        shallow
        className={clsx(
          classes.item,
          classes.item__leftArrow,
          currentPage === 1 && classes.item__disabled,
        )}
      >
        <TbChevronsLeft />
      </Link>

      {paginationRange &&
        paginationRange.map((pageNumber, idx) =>
          typeof pageNumber === 'number' ? (
            <Link
              key={idx}
              href={urlQueryParams(pageNumber)}
              passHref
              shallow
              className={clsx(
                classes.item,
                pageNumber === currentPage && classes.item__selected,
              )}
            >
              <Text as={'span'}>{pageNumber}</Text>
            </Link>
          ) : (
            <Text
              as={'span'}
              key={idx}
              className={clsx(classes.item, classes.item__dots)}
            >
              &#8230;
            </Text>
          ),
        )}

      <Link
        key={'arrow-right'}
        href={urlQueryParams(currentPage + 1)}
        passHref
        shallow
        className={clsx(
          classes.item,
          classes.item__rightArrow,
          currentPage === lastPage && classes.item__disabled,
        )}
      >
        <TbChevronsRight />
      </Link>
    </nav>
  )
}
